<div class="embed-responsive embed-responsive-16by9">
  <div class="video-media-player-content">
    <video
      #video
      class="azuremediaplayer amp-default-skin"
      width="100%"
      height="100%"
      layout="responsive"
      controls
    >
      <div fallback>
        <p class="amp-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that supports HTML5 video
        </p>
      </div>
    </video>
  </div>
</div>

